/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

  UPDATE_USER_INFO (state, payload) {

      for (const property of Object.keys(payload)) {
          if (payload[property] !== null) {
            state.user[property] = payload[property]

          }

      }
  },

}
